import React from 'react';
import styled from 'styled-components';

const Card = styled.div<{ $w?: number; $h?: number }>`
    border-radius: 0;
    background: #fff;
    overflow: auto;

    width: ${({ $w }) => ($w ? `${$w}px` : '100%')};
    height: ${({ $h }) => ($h ? `${$h}px` : '100%')};

    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    padding: 10px 12px;
    min-height: 44px;
    flex: 0 0 auto;
`;

const Body = styled.div`
    padding: 12px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
`;

const Footer = styled.div`
    padding: 10px 12px;
    border-top: 1px solid #f0f0f0;
    flex: 0 0 auto;
`;

const MediaFrame = styled.div<{ $h: number; $fit?: 'contain' | 'cover' }>`
    width: 100%;
    height: ${({ $h }) => $h}px;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img,
    video,
    canvas {
        width: 100%;
        height: 100%;
        object-fit: ${({ $fit }) => $fit || 'contain'} !important;
        display: block;
    }
`;

type Props = {
    dataTestId?: string;
    headerRight?: React.ReactNode;
    kebab?: React.ReactNode;
    media?: React.ReactNode;
    children?: React.ReactNode;

    footerLeft?: React.ReactNode;
    footerRight?: React.ReactNode;

    headerStyle?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
    footerStyle?: React.CSSProperties;

    cardWidth?: number;
    mediaHeight?: number;
    cardHeight?: number;
};

export default function PhotoCardShell({
    dataTestId,
    headerRight,
    kebab,
    media,
    children,
    footerLeft,
    footerRight,
    headerStyle,
    bodyStyle,
    footerStyle,
    cardWidth,
    mediaHeight = 193,
    cardHeight,
}: Props) {
    return (
        <Card data-test-id={dataTestId} $w={cardWidth} $h={cardHeight}>
            <Header style={headerStyle}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {headerRight}
                    {kebab}
                </div>
            </Header>

            {/* fixed */}
            {media && <MediaFrame $h={mediaHeight}>{media}</MediaFrame>}

            {/* dynamic */}
            {/*{children && <Body style={bodyStyle}>{children}</Body>}*/}

            {children && (
                <Body
                    style={{
                        ...bodyStyle,
                        overflow: 'auto',        /* ล็อคค่านี้ไว้เสมอ */
                        display: 'flex',         /* ล็อคค่านี้ไว้เสมอ */
                        flexDirection: 'column', /* ล็อคค่านี้ไว้เสมอ */
                    }}
                >
                    {children}
                </Body>
            )}

            {(footerLeft || footerRight) && (
                <Footer style={footerStyle}>
                    <div>{footerLeft}</div>
                    <div>{footerRight}</div>
                </Footer>
            )}
        </Card>
    );
}
